import { Module } from "wrapper6";

export default class CoverSlider extends Module {
  ready() {
    if (typeof coverData !== 'undefined') {
      this.currentSlide = 0;
      this.firstSlide = 0;
      this.imageZIndex = 2;
      this.intervalTime = 8000;
      this.fadeTime = 2000;
      this.running = true;
      this.totalSlides = coverData.length;
      this.lastSlide = this.totalSlides - 1;
      this.slideInterval;
      this.slideIntervals = [];

      this.touchstartX = 0;
      this.touchstartY = 0;
      this.touchendX = 0;
      this.touchendY = 0;

      this.coverElement = document.querySelector('.mtt-cover-image--slider');
      this.titleElement = this.coverElement.querySelector('h1');
      this.taglineElement = this.coverElement.querySelector('.mtt-tagline');
      this.linksElement = this.coverElement.querySelector('.mtt-cover-image__links');
      this.boxElement = this.coverElement.querySelector('.mtt-cover-image__box');


      const LINES = document.querySelectorAll('.lines .line');

      for (let i = 0; i < LINES.length; i++) {
        const LINE = LINES[i];

        LINE.addEventListener('click', e => {
          this.changeSlide(parseInt(LINE.getAttribute('data-num')));
        })
      }

      this.init();

      this.coverElement.addEventListener('touchstart', (event) => {
        this.touchstartX = event.changedTouches[0].screenX;
        this.touchstartY = event.changedTouches[0].screenY;

      }, false);
      
      this.coverElement.addEventListener('touchend', (event) => {
        this.touchendX = event.changedTouches[0].screenX;
        this.touchendY = event.changedTouches[0].screenY;
        this.handleGesure();
      
      }, false); 
    }
  }

  init() {

    for (let i = 0; i < this.slideIntervals.length; i++) {
      const interval = this.slideIntervals[i];
      window.clearTimeout(interval);
    }

    this.slideIntervals = [];

    this.slideInterval = setTimeout(() => this.changeSlide(), this.intervalTime);
    this.slideIntervals.push(this.slideInterval);
  }

  handleGesure() {
    
    if (this.touchendX > this.touchstartX) {
      this.changeSlideBack();
      return;
    }
    if (this.touchendY > this.touchstartY) {
      this.changeSlide();
      return;
    }
  }

  changeSlide(force = null) {
    this.currentSlide === this.lastSlide ? this.currentSlide = this.firstSlide : this.currentSlide += 1;
    if(force){
      window.clearTimeout(this.slideInterval);
      this.currentSlide = force;
    }
    let activeElement = document.querySelector('.line.active');
    let newElement = document.querySelector('[data-num="'+this.currentSlide+'"]');
    activeElement.classList.remove('active');
    newElement.classList.add('active');
    this.loadImage(coverData[this.currentSlide]['image_src']);
  }

  changeSlideBack(force = null) {
    this.currentSlide === this.firstSlide ? this.currentSlide = this.lastSlide : this.currentSlide -= 1;
    if(force){
      window.clearTimeout(this.slideInterval);
      this.currentSlide = force;
    }
    let activeElement = document.querySelector('.line.active');
    let newElement = document.querySelector('[data-num="'+this.currentSlide+'"]');
    activeElement.classList.remove('active');
    newElement.classList.add('active');
    this.loadImage(coverData[this.currentSlide]['image_src']);
  }

  setTitle() {
    this.titleElement.innerText = coverData[this.currentSlide]['text'];
  }

  setTagline() {
    try {
      this.taglineElement.innerText = coverData[this.currentSlide]['tagline'];
    } catch (e) {
      //tagline not present
    }
  }

  setBoxPosition() {
    this.boxElement.style.cssText = coverData[this.currentSlide]['box_position'];
  }

  setLinks() {
    if (coverData[this.currentSlide]['links'].length) {
      let links = '';

      for (let i = 0; i < coverData[this.currentSlide]['links'].length; i++) {
        const LINK = coverData[this.currentSlide]['links'][i];
        links += this.linkTemplate(LINK);
      }

      this.linksElement.innerHTML = links;
    } else {
      this.linksElement.innerHTML = '';
    }
  }

  linkTemplate(link) {
    let linkClasses = 'mtt-arrow-link mtt-arrow-link--blue';
    return `<a href="${link.link}" class="${linkClasses}">${link.title}</a>`;
  }

  setImage() {
    const IMG = this.createImageElement();
    const OLD_IMG = this.coverElement.querySelector('.mtt-cover-image__image');

    OLD_IMG.classList.add('mtt-cover-image__image--fade');
    this.coverElement.insertBefore(IMG, OLD_IMG);

    setTimeout(() => {
      this.coverElement.removeChild(OLD_IMG);
    }, this.fadeTime)
  }

  setBackground() {
    const IMAGE_CONTAINER = this.createImageWrapper();
    const OLD_IMAGE_CONTAINER = this.coverElement.querySelector('.mtt-cover-image__image');

    OLD_IMAGE_CONTAINER.classList.add('mtt-cover-image__image--fade');

    IMAGE_CONTAINER.style.backgroundImage = `url(${coverData[this.currentSlide]['image_src']})`;
    IMAGE_CONTAINER.style.backgroundSize = 'cover';
    IMAGE_CONTAINER.style.backgroundPosition = 'center center';
    IMAGE_CONTAINER.style.backgroundRepeat = 'no-repeat';

    this.coverElement.insertBefore(IMAGE_CONTAINER, OLD_IMAGE_CONTAINER);

    setTimeout(() => {
      this.coverElement.removeChild(OLD_IMAGE_CONTAINER);
    }, this.fadeTime)
  }

  createImageWrapper() {
    let imageContainerElement = document.createElement('div');
    imageContainerElement.className = 'mtt-cover-image__image object-fit';

    return imageContainerElement;
  }

  createImageElement() {
    let imageContainerElement = this.createImageWrapper();
    let imageElement = document.createElement('img');

    imageElement.setAttribute('src', coverData[this.currentSlide]['image_src']);
    imageElement.setAttribute('alt', coverData[this.currentSlide]['image_alt'])
    imageContainerElement.appendChild(imageElement);

    return imageContainerElement;
  }

  loadImage(imageSrc) {
    const image = new Image();

    image.onload = () => {
      this.setTitle();
      this.setTagline();
      this.setBoxPosition();
      this.setLinks();
      this.objectFitSupported ? this.setImage() : this.setBackground();
      this.init();
    };

    image.src = imageSrc;
  }

  get objectFitSupported() {
      return 'objectFit' in document.documentElement.style;
  }
}
